import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../../hoc/Aux';
import axios from '../../axios-ns';
import * as messages from '../../messages';
import OptIn from '../OptIn/OptIn';

class Articles extends Component {

    render() {
        return (
            <Aux>
                <Card style={{ border: 'none', width: '100%', maxWidth: '1000px', borderRadius: '5px', boxShadow: '0px' }}>
                    <h1 style={{ padding: '10px', backgroundImage: 'url(http://nauka-spiewu.pl/assets/images/cartoon/backgroundSky.JPG)', color: '#fff', marginTop: '-10px' }}>Literatura</h1>
                    <p style={{ padding: '10px', fontWeight: 'bold', color: '#555' }}>
                    Poniżej znajdziesz linki do interesujących materiałów potwierdzających tezę, że praktycznie każdy może dobrze śpiewać!
                    <ul>
                        <li><a href="https://www.youtube.com/watch?v=l1CbyVxfQjM&list=RD2NWbSuCrF8o&index=5" target="_blank">Zobacz co mówi Felicia Ricci, znany "Voide Finder" o nauce śpiewu</a></li>
                        <li><a href="http://discovermagazine.com/2014/julyaug/11-singing-in-the-brain" target="_blank">Magazyn Discover o śpiewie</a></li>
                        <li><a href="https://blogs.voanews.com/science-world/2015/02/10/practice-is-the-key-to-good-singing/" target="_blank">Sciencie World - w nawiązaniu do badań profesora Stevena Demorest'a</a></li>
                        <li><a href="https://www.youtube.com/watch?v=2NWbSuCrF8o" target="_blank">30 dniowe wyzwanie</a></li>
                        <li><a href="https://www.youtube.com/watch?v=OUanAnD4Eew" target="_blank">Kto może śpiewać</a></li>
                        <li><a href="https://www.medicaldaily.com/how-sing-practice-more-important-natural-ability-science-says-322320" target="_blank">Artykuł w Medical Daily</a></li>
                    </ul>
                    </p>
                </Card>
            </Aux>
        );
    }
}

export default Articles; 